<div class="relative w-full overflow-hidden inline-grid"
     (mouseenter)="pause()"
     (mouseleave)="play()">
    <!-- Track container -->
    @if(showCarets){
        <div class="md:flex justify-end">
            <button
                    type="button"
                    class="md:relative md:top-4 absolute z-10 left-0 m-2 top-1/2 -translate-y-1/2 bg-primary-hover p-2 rounded-full shadow hover:bg-card-hover"
                    (click)="prevSlide()"
            >
            <span class="material-icons text-normal">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                  <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                </svg>
            </span>
            </button>
            <button
                    type="button"
                    class="md:relative  md:top-4 absolute z-10 right-0 top-1/2 m-2 -translate-y-1/2 bg-primary-hover p-2 rounded-full shadow hover:bg-card-hover"
                    (click)="nextSlide()"
            >
            <span class="material-icons text-normal">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                  <path d="M8.59 16.59L13.17 12l-4.58-4.59L10 6l6 6-6 6-1.41-1.41z"/>
                </svg>
            </span>
            </button>
        </div>
    }
    <div class="grid overflow-hidden ">
        <div #track class="grid  grid-flow-col gap-4"
             style="transform: translateX(0); transition: transform 0.7s ease-in-out;">
            <!-- Render the original templates -->
            @for (tmpl of templates; track $index){
                <ng-container >
                    <ng-container *ngTemplateOutlet="tmpl"></ng-container>
                </ng-container>
            }

        </div>

    </div>
    <div class="absolute h-full w-20 top-0 left-0 bg-gradient-to-r from-bg_primary to-transparent"></div>

    <div class="absolute h-full w-20 top-0 right-0 bg-gradient-to-l from-bg_primary to-transparent"></div>
</div>